import { useEffect } from 'react';

import { useGlobalAppState } from '../GlobalAppState/GlobalAppState';

// ─────────────────────────────────────────────────────────────────────────────

export const useInitializeDietaryPreferences = () => {
  const { dietaryRestrictionsMachineRef: actor } = useGlobalAppState();

  useEffect(() => {
    actor.send({ type: 'INITIALIZE' });
  }, [actor]);
};
